import { serverDayToDateObject } from '@/helpers/dates'

// Writes that can leave a drop with no open fulfillment date list the drops
// they affected under `meta.affected_drops`.
export const affectedDropsFrom = response => response?.data?.meta?.affected_drops || []

const dayFormat = new Intl.DateTimeFormat('en-US', { weekday: 'short', month: 'short', day: 'numeric' }).format
const datetimeFormat = new Intl.DateTimeFormat('en-US', {
  weekday: 'short',
  month: 'short',
  day: 'numeric',
  hour: 'numeric',
  minute: '2-digit'
}).format
const countFormat = new Intl.NumberFormat('en-US').format

export const formatDropDay = day => dayFormat(serverDayToDateObject(day))

export const formatReminderAt = datetime => (datetime ? datetimeFormat(new Date(datetime)) : null)

export const formatRecipientCount = count => `${countFormat(count || 0)} ${count === 1 ? 'customer' : 'customers'}`

export const dropCountLabel = count => `${count} ${count === 1 ? 'drop' : 'drops'}`

export const affectedDropsToastMessage = drops => {
  if (!drops.length) return ''
  const [first, ...rest] = drops
  const subject = rest.length ? `${first.description} and ${dropCountLabel(rest.length)} other` : first.description
  const verb = rest.length ? 'now have' : 'now has'
  return `${subject} ${verb} no fulfillment date. Reminders for ${rest.length ? 'them' : 'it'} will not send.`
}

// What a delete or an "all future drops" save would actually do, read from the
// impact endpoint before the write is made. `drops` lists only the affected
// drops that have orders on them; `totals` covers every affected drop.
export const dropImpactFrom = response => {
  const meta = response?.data?.meta || {}
  return { drops: meta.drops || [], totals: meta.totals || {} }
}

// Whether an "all future drops" save is worth stopping the merchant for. A
// delete always is, so it asks no question; a save happens per field edit, and
// prompting on every one would be unusable.
//
// An update rebuilds what it tears down, so pending reminders, autocharge and
// autofill all come back and are not worth a prompt. Orders are - they stay on
// the row being replaced - and so is a reminder that has already sent, because
// the rebuilt drop schedules it again.
export const updateNeedsConfirming = ({ totals = {} } = {}) => Boolean(totals.order_count || totals.sent_reminder_count)

// A cascade delete takes the rest of the chain with it. The response body only
// describes the drop in the URL, so the ids of everything else it removed come
// back under `meta.deleted_drop_ids`.
export const deletedDropIdsFrom = response => (response?.data?.meta?.deleted_drop_ids || []).map(id => String(id))

// Drops left behind by a chain-wide save or delete are shown in
// DropsWithOrdersModal rather than a toast - the merchant needs to read which
// drops they are and follow a link to the orders holding them.
